// extracted by mini-css-extract-plugin
module.exports = {"navBarTeam":"styles_navBarTeam__3cZ_1","infoChatbot":"styles_infoChatbot__1Z8UT","chatbotsContainer":"styles_chatbotsContainer__33STL"};